import React, { useState } from 'react';
import { styled } from '@mui/system';
import { AppBar, Toolbar, Box, useMediaQuery, Theme, Stack, IconButton, Collapse } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import { createCloudinaryLegacyURL } from '@cloudinary/url-gen';
import { useNavigate } from 'react-router-dom';
// components
import LinkButtons from './LinkButtons';

const CustomToolbar = styled(Toolbar)({
});

const Header: React.FC = () => {
  const [open, setOpen] = useState<boolean>(false);

  const isMobileSize = useMediaQuery((theme: Theme) => theme.breakpoints.down('sm'));

  const titleLogoUrl = createCloudinaryLegacyURL(
    'ofm/title_logo',
    { cloud_name: process.env.REACT_APP_CLOUDINARY }
  );

  const navigate = useNavigate();
  const renderLogo = (
    <Box
      component='img'
      src={titleLogoUrl}
      sx={{
        maxHeight: 48,
        '&:hover': {
          filter: 'brightness(0.6)'
        },
        filter: 'brightness(1)'
      }}
      onClick={() => {
        const pathName = '/';
        if (window.location.pathname !== pathName) {
          navigate(pathName);
        } else {
          window.location.reload();
        }
      }}
    />
  );

  return (
    <AppBar>
      <CustomToolbar>
        {isMobileSize
          ? (
            <Stack sx={{ width: '100%' }}>
              <Stack direction='row'>
                {renderLogo}
                <IconButton
                  onClick={() => setOpen(!open)}
                  sx={{ justifyContent: 'flex-end', marginLeft: 'auto' }}
                >
                  <MenuIcon sx={{ color: 'white' }} />
                </IconButton>
              </Stack>
              <Collapse in={open} unmountOnExit>
                <LinkButtons direction='column' onClick={() => setOpen(false)} />
              </Collapse>
            </Stack>
          )
          : (
            <>
              {renderLogo}
              <LinkButtons direction='row' />
            </>
          )
        }
      </CustomToolbar>
    </AppBar >
  );
};

export default Header;
